
<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <vs-alert
        v-if="$validator.errors.all().length >0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height:auto !important"
      >
        <ul>
          <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">{{ error }}</li>
        </ul>
      </vs-alert>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <span>Nome do Acessório</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formCadastro.nomeAcessorio"
            v-validate="{ required: true, min:3 }"
            :state="validateState('Nome')"
            :danger="validateClass('Nome')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="success" class="mr-3 mb-2">Adicionar</vs-button>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import locale from "./../../locale";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../services";
import jwt from "jsonwebtoken";
export default {
  props: ["tipo", "entidade", "pk", "tipoCadastro", "idGrupo"],
  watch: {
    tipoVeiculo(value) {
      this.form.codigoTipoVeiculo = value.id;
      this.marca = null;
      this.buscaDadosMarcas();
    },
    marca(value) {
      this.form.codigoMarca = value.id;
      this.modelo = null;
      if (this.tipoCadastro == "Modelo") this.buscaDadosModelos();
    },
    modelo(value) {
      this.form.codigoModelo = value.id;
    }
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      languages: lang,
      funcoesValicao: null,
      formCadastro: {
        idEmpresa: null,
        idGrupo: null,
        nomeAcessorio: null
      }
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;
      this.formCadastro.idGrupo = this.idGrupo;

      var action = "Adicionar";
      var msgRetorno = "Registro Adicionado com sucesso";

      console.log(this.formCadastro);
      this.$validator.validateAll().then(result => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post(this.entidade, action, this.formCadastro)
            .then(res => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success"
              });
              this.$emit("add");
            })
            .catch(error => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger"
              });
            });
        }
      });
    }
  },
  mounted() {
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    "v-select": vSelect
  }
};
</script>
<!------------ END SCRIPT ------------>
